<div class="grid-x grid-padding-x search__grid">
  <ng-container *ngIf="isGlobalSearch">
    <div class="cell shrink" *ngIf="advancedSearchIndex > 0">
      <mat-form-field class="search__modifier">
        <mat-select [(ngModel)]="searchObject.or" value="false">
          <mat-option value="false">And</mat-option>
          <mat-option value="true">Or</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="cell shrink">
      <mat-form-field>
        <mat-select
          placeholder="Search in field "
          (selectionChange)="changeSearchField()"
          [(ngModel)]="searchObject.field"
          data-cy="searchField"
          required
        >
          <mat-option value="search_text">Document Text</mat-option>
          <mat-option *ngFor="let field of searchFields | keyvalue" [value]="field.key">
            {{ field.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="cell shrink" *ngIf="searchObject.field === 'template_data'">
      <mat-form-field>
        <mat-select
          placeholder="Template field"
          data-cy="templateField"
          [value]="templateFields[0].label"
          [(ngModel)]="searchObject.templateField"
          (selectionChange)="changeSearchTemplateField($event)"
          required
        >
          <mat-option *ngFor="let field of templateFields" [value]="field.label">{{ field.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="cell shrink" *ngIf="searchObject.templateFieldType === 'address'">
      <mat-form-field>
        <mat-select
          placeholder="Select address field"
          data-cy="addressField"
          [(ngModel)]="searchObject.subfield"
          required
        >
          <mat-option *ngFor="let field of addressFields" [value]="field.value">{{ field.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="cell shrink">
      <mat-form-field>
        <mat-select
          placeholder="Search criteria "
          [(ngModel)]="searchObject.operator"
          [value]="searchObject.field === 'search_text' ? 'partial' : ''"
          [disabled]="searchObject.field === 'search_text'"
          data-cy="searchCriteria"
          required
        >
          <mat-option *ngFor="let option of getSearchOptions() | keyvalue" [value]="option.key">{{
            option.value
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div
      class="cell shrink"
      *ngIf="
        searchObject.operator !== 'range' &&
        searchObject.field !== 'template_id' &&
        searchObject.templateFieldType !== 'date' &&
        searchObject.templateFieldType !== 'range' &&
        searchObject.field !== 'document_tag_ids'
      "
    >
      <mat-form-field class="search__box">
        <i matPrefix class="fa fa-search search__icon padding-right-1"></i>
        <mat-label>Enter keyword</mat-label>
        <input
          matInput
          class="search__box-value"
          [type]="searchObject.templateFieldType === 'time' ? 'time' : 'text'"
          [textMask]="
            searchObject.templateFieldType === 'phone' ? { mask: 'phone_number' | inputMask } : { mask: false }
          "
          [(ngModel)]="searchObject.value"
          required
          data-cy="searchValue"
        />
        <i matSuffix class="fa fa-times search__x" (click)="clearSearchValue()"></i>
      </mat-form-field>
    </div>

    <div class="cell shrink" *ngIf="searchObject.field === 'template_id'">
      <mat-form-field class="search__box">
        <i matPrefix class="fa fa-search search__icon padding-right-1"></i>
        <mat-label>Select Template</mat-label>

        <mat-select
          placeholder="Select Template"
          [(ngModel)]="searchObject.value"
          (selectionChange)="activateSearch()"
          required
          data-cy="searchValue"
        >
          <mat-option *ngFor="let template of userTemplates" [value]="template.id">
            {{ template.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <ng-container *ngIf="tags$ | async as tags">
      <div class="cell shrink" *ngIf="searchObject.field === 'document_tag_ids'">
        <mat-form-field class="search__box">
          <i matPrefix class="fa fa-search search__icon padding-right-1"></i>
          <mat-label>Select Tag</mat-label>

          <mat-select
            placeholder="Select a Tag"
            [(ngModel)]="searchObject.value"
            (selectionChange)="activateSearch()"
            required
            data-cy="searchValue"
          >
            <mat-option *ngFor="let tag of tags" [value]="tag.id">
              {{ tag.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </ng-container>

    <div
      class="cell shrink"
      *ngIf="
        searchObject.operator === 'range' ||
        searchObject.templateFieldType === 'date' ||
        searchObject.templateFieldType === 'range'
      "
    >
      <mat-form-field class="search__box" data-cy="pickerFrom">
        <mat-label>{{
          searchObject.templateFieldType === 'date' && searchObject.operator !== 'range' ? 'Date' : 'From'
        }}</mat-label>
        <input
          matInput
          [matDatepicker]="pickerFrom"
          data-cy="pickerFromValue"
          [(ngModel)]="searchObject.range.from"
          (dateChange)="activateSearch()"
          required
        />
        <mat-datepicker-toggle matPrefix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
      </mat-form-field>
    </div>

    <div
      class="cell shrink"
      *ngIf="searchObject.operator === 'range' || searchObject.templateFieldType === 'range'"
      data-cy="pickerTo"
    >
      <mat-form-field class="search__box">
        <mat-label>To</mat-label>
        <input matInput [matDatepicker]="pickerTo" [(ngModel)]="searchObject.range.to" required />
        <mat-datepicker-toggle matPrefix [for]="pickerTo"></mat-datepicker-toggle>
        <mat-datepicker #pickerTo></mat-datepicker>
      </mat-form-field>
    </div>
  </ng-container>

  <!-- This block of search if for the table search in admin section -->
  <ng-container *ngIf="!isGlobalSearch">
    <div class="cell shrink">
      <mat-form-field>
        <mat-select
          placeholder="Search in field"
          (selectionChange)="changeSearchField($event)"
          data-cy="searchField"
          required
          [(ngModel)]="searchObject.field"
        >
          <mat-option *ngFor="let field of searchFields | keyvalue" [value]="field.key">
            {{ field.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="cell shrink">
      <mat-form-field
        *ngIf="searchObject.operator !== 'range' && searchObject.field !== 'template_id'"
        class="search__box"
      >
        <i matPrefix class="fa fa-search search__icon padding-right-1"></i>
        <mat-label>Enter keyword</mat-label>
        <input matInput #searchValue [(ngModel)]="searchObject.value" required data-cy="searchValue" />
        <i matSuffix class="fa fa-times search__x" (click)="clearSearchValue()"></i>
      </mat-form-field>
    </div>
  </ng-container>

  <div class="cell shrink">
    <button mat-mini-fab color="warn" (click)="removeSearch()" class="search__button">-</button>
    <button
      *ngIf="plusButtonEnabled"
      mat-mini-fab
      color="primary"
      (click)="plusButtonClicked.emit()"
      class="search__button margin-left-1"
    >
      +
    </button>
  </div>

  <div *ngIf="hasError" class="cell margin-top-1">
    <p class="alert-color">Please populate all required search fields</p>
  </div>
</div>

<hr *ngIf="!plusButtonEnabled" />
